import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import { FormatLocaleDateTime } from '@ukpostbox/helpers';
import React from 'react';
import { ListItem } from '@ukpostbox/frontend-framework';
import { LoginHistoryType } from '@ukpostbox/client-data';
import { BrowserIcon, UserDevice } from '../Util/LoginHistoryUtils';
import { useSite } from '../../../../../_Global/Providers/SiteInterfaceProvider';

function LoginHistoryEntry(item: LoginHistoryType) {
	const { currentLocale } = useSite();

	return (
		<ListItem
			title={item.userAgent ? UserDevice(item.userAgent) : 'Unknown'}
			description={`${item.city}, ${item.country} • ${item.ipAddress}`}
			static
			iconContent={{ icon: item.userAgent ? BrowserIcon(item.userAgent) : faCircleQuestion }}
			addonRight={{
				content: FormatLocaleDateTime(item.loginDate, currentLocale),
				hideArrow: true,
			}}
		/>
	);
}

export { LoginHistoryEntry };
